module.exports = __webpack_public_path__ + "img/student.e82ad650.png";